import React from "react";
import { SEO, PageLayout, OutboundLink } from "@bluefin/components";
import { Grid, Button } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getComponentFiles } from "../utils/utils";

export default class CareersPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
        />
        <PageLayout
          hero={null}
          subfooter={false}
          className={"about-page careers-page"}
        >
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            centered={true}
            textAlign={"center"}
          >
            <Grid.Column width={8} textAlign={"center"}>
              <h2>Join Our Team</h2>
              <p>
                We’re always looking for friendly, hardworking individuals to
                join our team! Apply below for positions in our convenience
                store, deli, or liquor store.
              </p>
            </Grid.Column>
          </Grid>
          <Grid
            stackable={true}
            className={"component-section-container career-form-container"}
            verticalAlign={"middle"}
            textAlign={"left"}
            centered={true}
          >
            <Grid.Column width={8}>
              <Button
                primary={true}
                size={"large"}
                to={
                  "https://docs.google.com/forms/d/e/1FAIpQLSc8qUPNg6IlqcKPhnhQUA2ePONU909qEmRrifkECpjLdn_8jw/viewform?pli=1"
                }
                as={OutboundLink}
              >
                Apply Now
              </Button>
            </Grid.Column>
          </Grid>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(title: { eq: "Careers" }) {
      title
      description
      components {
        fastId
        componentIdentifier
        order
        files {
          file
        }
      }
    }
  }
`;
